import * as React from "react";
import auth from "../../../../Auth";
import { Grid, GridColumn as Column, GridColumn, GridNoRecords } from "@progress/kendo-react-grid";
import { CellRender, GridNoRecord, NumberCell, StatusCell } from "../../../../Shared/GridComponents/CommonComponents";
import axios from "axios";
import CompleteSearch from "../../../../Shared/Search/CompleteSearch";
import ColumnMenu from "../../../../Shared/GridComponents/ColumnMenu";
import RowActions from "../../../../Shared/Workflow/RowActions";
import { CustomMenu, DefaultActions, DetailColumnCell, ViewMoreComponent } from "./GlobalActions";
import { State, toODataString } from "@progress/kendo-data-query";
import CreateDefaultShift from "../CreateDefaultShift/CreateDefaultShift";
import { Dialog } from "@progress/kendo-react-dialogs";
import { downloadExcel, history, initialDataState, successToastr } from "../../../../../HelperMethods";
import ConfirmationModal from "../../../../Shared/ConfirmationModal";
import { faPlusCircle, faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { AppPermissions } from "../../../../Shared/Constants/AppPermissions";
import { DEF_SHIFT_REMOVE_SUCCESS_MSG, EXCEL_DOWNLOAD_INPROGRESS, REMOVE_DEPT_DEF_SHIFT_CONFIRMATION_MSG } from "../../../../Shared/AppMessages";
import BreadCrumbs from "../../../../Shared/BreadCrumbs/BreadCrumbs";
import clientAdminService from "../../Service/DataService";
import { KendoFilter } from "../../../../ReusableComponents";
import { LocalizationHelper } from "../../../../../Localization/helpers/LocalizationHelper";
import { LocalizationResource } from "../../../../Shared/AppConstants";

export interface DefaultShiftsProps {
    match: any;
    onCloseModal: any;
    location: any;
}

export interface DefaultShiftsState {
    defaultShifts: any;
    clientId?: string;
    departmentId?: string;
    locationId?: string;
    onFirstLoad: boolean;
    totalCount?: number;
    totalDefaultShifts?: any;
    showLoader?: boolean;
    showAddNewShiftModal?: any;
    showEditModal?: boolean;
    showRemoveModal?: boolean;
    showDeleteModal?: boolean;
    dataState: any;
}

class DefaultShifts extends React.Component<DefaultShiftsProps, DefaultShiftsState> {
    public dataItem: any;
    public locId: string;
    constructor(props: DefaultShiftsProps) {
        super(props);
        const { locationId } = this.props.match.params;
        const { departmentId } = this.props.match.params;
        this.state = {
            defaultShifts: [],
            dataState: initialDataState,
            clientId: auth.getClient(),
            departmentId: departmentId,
            locationId: locationId,
            onFirstLoad: true,
            showLoader: true,
        };
    }

    getDefaultShifts = (dataState) => {
        this.setState({ showLoader: true, onFirstLoad: false });
        var queryStr = `${toODataString(dataState, { utcDates: true })}`;
        let queryParams = `locationId eq ${this.state.locationId} and departmentId eq ${this.state.departmentId}`;

        var finalQueryString = KendoFilter(dataState, queryStr, queryParams);

        clientAdminService.getDefaultShifts(finalQueryString).then((res) => {
            this.setState({
                defaultShifts: res.data.items,
                showLoader: false,
                dataState: dataState,
                totalCount: res.data.count
            });
        });
    }

    getDefaultShiftCount = () => {
        if (this.state.defaultShifts.length === 0) {
            return;
        }
        var finalState: State = {
            ...this.state.dataState,
            take: null,
            skip: 0,
        };
        successToastr(EXCEL_DOWNLOAD_INPROGRESS);
        var queryStr = `${toODataString(finalState)}`;
        let queryParams = `locationId eq ${this.state.locationId} and departmentId eq ${this.state.departmentId}`;
        var finalQueryString = KendoFilter(finalState, queryStr, queryParams);
        clientAdminService.getDefaultShiftsExcel(finalQueryString).then((res: any) => {
            if (res) {
                downloadExcel("Manage Default Shifts.xlsx", res.data);
            }
        });
    };

    onDataStateChange = (changeEvent) => {
        this.getDefaultShifts(changeEvent.dataState);
        localStorage.setItem("ManageDefaultShifts-GridDataState", JSON.stringify(changeEvent.dataState));
    };

    handleActionClick = (action, actionId, rowId, nextStateId?, eventName?, dataItem?) => {
        let change = {};
        let property = `show${action.replace(/ +/g, "").replace(".", "")}Modal`;
        change[property] = true;
        this.setState(change);
        this.dataItem = dataItem;
    }

    AddNewModal = () => {
        this.dataItem = undefined
        this.setState({ showAddNewShiftModal: true })
    }

    deleteDefaultShift = (id, msg) => {
        this.setState({ showDeleteModal: false, showRemoveModal: false });
        clientAdminService.deleteDefaultShifts(id).then((res) => {
            successToastr(msg);
            this.getDefaultShifts(this.state.dataState);
            this.dataItem = undefined;
        });
    };

    openModal = (prop, dataItem) => {
        this.setState({ showDeleteModal: true });
    };

    ExpandCell = (props) => <DetailColumnCell {...props} expandChange={this.expandChange.bind(this)} />;

    expandChange = (dataItem) => {
        const { defaultShifts } = this.state;
        const shift = defaultShifts.map((item) => {
          if (item === dataItem) {
            item.expanded = !item.expanded;
          }
          return item;
        });
        this.setState({
            defaultShifts: shift
        });
    };

    render() {
        return (
            <div className="col-11 mx-auto pl-0 pr-0 mt-3  mt-md-0">
                <div className="container-fluid mt-3 mb-3 d-md-block d-none">
                    <div className="row pt-2 pb-2 mt-3 accordianTitleClr mx-auto mb-2">
                        <div className="col-10 fonFifteen paddingLeftandRight">
                            <BreadCrumbs globalData={{locationId:this.state.locationId, departmentId:this.state.departmentId, clientId: this.state.clientId}} ></BreadCrumbs>
                        </div>
                        <div className="col-2">
                            {auth.hasPermissionV2(AppPermissions.DEPARTMENT_SHIFT_CREATE) && (
                                <span className="float-right text-dark cusrsor-pointer "
                                    onClick={() => this.setState({ showAddNewShiftModal: true })}>
                                    <FontAwesomeIcon icon={faPlusCircle} className={"mr-2 text-dark"} />
                                    Add New Shift
                                </span>
                            )}
                        </div>
                    </div>
                </div>

                <div className="container-fluid">
                    <CompleteSearch
                        page="ManageDefaultShifts"
                        entityType={"Default Shifts"}
                        placeholder="Search text here!"
                        handleSearch={this.getDefaultShifts}
                        onFirstLoad={this.state.onFirstLoad}
                        persistSearchData={true}
                    />
                    <div className="manageDivisionContainer global-action-grid-lastchild">
                        <Grid
                            style={{ height: "auto" }}
                            sortable={true}
                            onDataStateChange={this.onDataStateChange}
                            pageable={{ pageSizes: true }}
                            data={this.state.defaultShifts}
                            {...this.state.dataState}
                            detail={ViewMoreComponent}
                            expandField="expanded"
                            total={this.state.totalCount}
                            className="kendo-grid-custom k-widget lastchild"
                        >
                            <GridNoRecords>{GridNoRecord(this.state.showLoader)}</GridNoRecords>
                            <GridColumn
                                field="location"
                                title={LocalizationHelper.getLocalizedTitle(LocalizationResource.Location_Label, "Location")}
                                cell={(props) => CellRender(props, "Location")}
                                columnMenu={ColumnMenu}
                                filter="text"
                            />
                            <GridColumn
                                field="department"
                                title={LocalizationHelper.getLocalizedTitle(LocalizationResource.Department_Label, "Department")}
                                cell={(props) => CellRender(props, "Department")}
                                columnMenu={ColumnMenu}
                                filter="text"
                            />
                            <GridColumn
                                field="shift"
                                title="Shift Name"
                                cell={(props) => CellRender(props, "Shift Name")}
                                columnMenu={ColumnMenu}
                                filter="text"
                            />
                            <GridColumn
                                field="shiftType"
                                title="Shift Type"
                                cell={(props) => CellRender(props, "shiftType")}
                                columnMenu={ColumnMenu}
                                filter="text"
                            />
                            <GridColumn
                                field="startTime"
                                filter="date"
                                format="{0:d}"
                                editor="date"
                                title="Start Time"
                                columnMenu={ColumnMenu}
                                cell={(props) => CellRender(props, "Start Time", null, null, true)}
                                width="125px"
                            />
                            <GridColumn
                                field="endTime"
                                filter="date"
                                format="{0:d}"
                                editor="date"
                                title="End Time"
                                columnMenu={ColumnMenu}
                                cell={(props) => CellRender(props, "End Time", null, null, true)}
                                width="125px"
                            />
                            <GridColumn
                                field="duration"
                                headerClassName="text-right pr-4"
                                title="Duration (In Hrs)"
                                filter="numeric"
                                cell={(props) => NumberCell(props, "Duration")}
                                columnMenu={ColumnMenu}
                                width="125px"
                            />
                            <GridColumn
                                field="position"
                                title="Position"
                                cell={(props) => CellRender(props, "Position(s)")}
                                columnMenu={ColumnMenu}
                            />
                            <GridColumn
                                field="status"
                                title="Status"
                                columnMenu={ColumnMenu}
                                cell={StatusCell}
                            />
                            <GridColumn
                                title="Action"
                                sortable={false}
                                width="70px"
                                cell={(props) => (
                                    <RowActions
                                        dataItem={props.dataItem}
                                        currentState={""}
                                        rowId={props.dataItem.clientDivId}
                                        handleClick={this.handleActionClick}
                                        defaultActions={DefaultActions(props)}
                                    />
                                )}
                                headerCell={() => CustomMenu(this.getDefaultShiftCount, this.AddNewModal)}
                            />
                            <GridColumn sortable={false} field="expanded"  width="100px" title="View More" cell={this.ExpandCell} />
                        </Grid>
                    </div>
                    <div className="modal-footer justify-content-center border-0">
                        <div className="row mt-2 mb-2 ml-0 mr-0 justify-content-center">
                            <button type="button" className="btn button button-close mr-2 shadow mb-2 mb-xl-0" onClick={() => history.goBack()}>
                                <FontAwesomeIcon icon={faTimesCircle} className={"mr-1"} /> Close
                            </button>
                        </div>
                    </div>
                </div>

                <ConfirmationModal
                    message={REMOVE_DEPT_DEF_SHIFT_CONFIRMATION_MSG()}
                    showModal={this.state.showRemoveModal}
                    handleYes={() => this.deleteDefaultShift(this.dataItem.shiftId, DEF_SHIFT_REMOVE_SUCCESS_MSG)}
                    handleNo={() => {
                        this.setState({ showRemoveModal: false });
                    }}
                />

                {this.state.showAddNewShiftModal && (
                    <div id="add-division">
                        <Dialog className="col-12 For-all-responsive-height">
                            <CreateDefaultShift
                                props={this.dataItem}
                                onCloseModal={() => this.setState({ showAddNewShiftModal: false }, () => { this.dataItem = undefined; this.getDefaultShifts(this.state.dataState) })}
                                onOpenModal={() => this.setState({ showAddNewShiftModal: true })}
                                locationId={this.state.locationId}
                                departmentId={this.state.departmentId}
                            />
                        </Dialog>
                    </div>
                )}

                {this.state.showEditModal && (
                    <div id="Edit-division">
                        <Dialog className="col-12 For-all-responsive-height">
                            <CreateDefaultShift
                                props={this.dataItem}
                                onCloseModal={() => this.setState({ showEditModal: false }, () => { this.dataItem = undefined; this.getDefaultShifts(this.state.dataState) })}
                                onOpenModal={() => this.setState({ showEditModal: false })}
                                locationId={this.state.locationId}
                                departmentId={this.state.departmentId}
                            />
                        </Dialog>
                    </div>
                )}
            </div>
        );
    }
}

export default DefaultShifts;